import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'

import {
  MEETING_STATUS_COUNTS_TO_LABEL_MAP,
  MEETING_STATUS_TO_COLOR_MAP,
  MEETING_STATUS_TO_LABEL_MAP,
} from '@modules/contacts/constants'
import { Meeting, MeetingStatus } from '@modules/contacts/types'

import { MeetingDateTime, MeetingEventName, MeetingEventNameContainer, MeetingTitle, MeetingTitleContainer } from './index.styles'

interface MeetingDataProps {
  meeting: Meeting
  isCountsOverview: boolean
  singleViewMode: boolean
}

const MeetingData = (props: MeetingDataProps) => {
  const { meeting, isCountsOverview, singleViewMode } = props
  const { t } = useTranslation()

  const meetingStatus = meeting?.status as MeetingStatus

  return (
    <>
      <MeetingTitleContainer $singleViewMode={singleViewMode}>
        <MeetingTitle variant="caption" color={MEETING_STATUS_TO_COLOR_MAP[meetingStatus]?.text}>
          {isCountsOverview ? (
            t(MEETING_STATUS_COUNTS_TO_LABEL_MAP[meetingStatus], { count: '' } as unknown as string)
          ) : (
            <>
              {t(MEETING_STATUS_TO_LABEL_MAP[meetingStatus], { count: '' } as unknown as string)} {!!meeting.event?.name && ': '}
            </>
          )}
        </MeetingTitle>
        <MeetingEventNameContainer>
          <MeetingEventName variant="caption">{meeting.event?.name}</MeetingEventName>
        </MeetingEventNameContainer>
      </MeetingTitleContainer>
      <MeetingDateTime variant="body1">
        {DateTime.fromISO(meeting.date || meeting.event.startDate).toFormat('MMM dd, yyyy')}
      </MeetingDateTime>
    </>
  )
}

export default MeetingData
